import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactSVG } from 'react-svg';
import { connect } from 'react-redux';
import vrIcon from '../../assets/images/tools-circle.svg';
import { popup_VrInfo_SetVisibility } from '../../actions/popup';
import { currentBrandSelector } from '../../helpers/selectors';

// The replacement-vehicle info sheet (mirror of the mobile RV service sheet):
// there is no self-signup for RV, the dealer hands out the registration link.
// Content lifted from the VR step of the removed SubscribeForm - deliberately
// no login button here.
function VrInfoPopup({ vrIconUrl, popup_VrInfo_SetVisibility }) {
  return (
    <div className="vr-info-popup text-center">
      <div className="f-25 mt-40 mb-10">
        <FormattedMessage id="service.usage.vr" />
      </div>
      <div className="mb-10">
        <ReactSVG className="react-svg" src={vrIconUrl || vrIcon} />
      </div>
      <div className="ws-pre-line mb-25">
        <FormattedMessage id="service.vr.intro" />
      </div>
      <div className="mb-35">
        <button
          className="btn btn-md btn-accent primary-btn"
          onClick={() => popup_VrInfo_SetVisibility(false)}
        >
          ok
        </button>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  const { servicesIcons } = currentBrandSelector(state) || {};

  return { vrIconUrl: servicesIcons?.vr };
}

const mapDispatchToProps = { popup_VrInfo_SetVisibility };

export default connect(mapStateToProps, mapDispatchToProps)(VrInfoPopup);
